import { Link } from 'react-router-dom';
import { Home, ShieldX, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function ForbiddenPage() {
  return (
    <div className="min-h-screen bg-dark-950 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 bg-error-500/10 rounded-full flex items-center justify-center">
          <ShieldX className="w-10 h-10 text-error-400" />
        </div>
        <h1 className="text-6xl font-bold text-error-400 mb-4">403</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Access Denied</h2>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">
          You don't have permission to access this page. If you believe this is an error,
          please contact support.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/">
            <Button leftIcon={<Home className="w-4 h-4" />}>
              Go Home
            </Button>
          </Link>
          <Button
            variant="secondary"
            leftIcon={<ArrowLeft className="w-4 h-4" />}
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
